import {getProducts} from "../api";

export function taxFilter() {

    let filterConfig = JSON.parse(localStorage.getItem('filterConfig'));
    console.log(filterConfig);



    const body = $("body");
    const win = $(window);
    let product_list = $(".product-list");

    if( product_list.length > 0 ) {

        let tags = $(".tax-filter-tags");
        let tax_filter = $(".tax-filter");
        let filter_option = $(".filter-option");
        let filter_wrap = tax_filter.find(".tax-filter-wrapper");

        let selects = filter_wrap.find('.selects');
        let block = selects.find(".block");
        let options = filter_wrap.find('.options');
        let options_block = options.find('.block');

        let free_books = $(".free-books");

        let selects_h = selects.outerHeight();

        let mobile_menu_toggle = $(".mobile-menu-toggle");
        let tax_filter_mobile = $(".tax-filter-mobile");

        function placeTags(filterConfig, action) {
            getProducts(filterConfig, action);
            hideFilter()
        }

        function hideFilter() {
            options.css("height", "auto");
            if(selects_h) {

                if(selects_h > 60) {
                    selects_h = 60;
                }

                filter_wrap.css("height", selects_h + "px");

            }
            tax_filter.addClass("show");
            body.removeClass("show-filter");
            tags.removeClass("hidden");

            block.each(function () {
                $(this).removeClass("active");
            });

            options_block.each(function () {
                $(this).removeClass("show");
            });

        }

        placeTags(filterConfig, "init");

        filter_option.on("click tap", function() {
            let me = $(this);
            let parent = me.parent();
            let action = parent.data("action");

            let name = me.find("span").text();

            let input = me.find("input");
            let value = me.data("value");
            let input_val = input.val();

            if(!value) {

                let obj = {
                    name: name,
                    value: input_val
                }

                if(input.is(':checked')) {
                    input.prop('checked', false);

                    // console.log("remove from filter");
                    $.each( filterConfig[action], function( key, value ) {

                        if(value) {
                            if ( input_val == value.value ) {
                                filterConfig[action].splice(key, 1);
                            }
                        }

                    });

                } else {

                    if($.inArray(obj, filterConfig[action]) === -1) {
                        input.prop('checked', true);
                        filterConfig[action].push(obj);
                    }
                }
            } else {

                let obj = {
                    name: name,
                    value: value
                }

                filterConfig[action] = obj;

            }

            filterConfig.load_more = false;
            filterConfig.offset = 0;
            filterConfig.load_count = filterConfig.load_default;
            filterConfig.loaded_count = filterConfig.load_default;
            filterConfig.loaded_posts = filterConfig.load_default;
            placeTags(filterConfig);

        });

        free_books.on("click tap", function() {
            let me = $(this);
            me.toggleClass("active");

            if (me.hasClass("active")) {
                filterConfig.offset = 0;
                filterConfig.load_more = false;
                filterConfig.free_books = true;
            } else {
                filterConfig.free_books = false;
                filterConfig.offset = 0;
                filterConfig.load_count = filterConfig.load_default;
                filterConfig.loaded_count = filterConfig.load_default;
                filterConfig.loaded_posts = filterConfig.load_default;
            }

            console.log(filterConfig);

            if(!product_list.hasClass("loading")) {
                placeTags(filterConfig);
            }

        });

        block.on("click tap", function () {
            let me = $(this);
            let filter = me.data("show-filter");

            let block = tax_filter.find('.tax-filter-wrapper .options .block[data-action="'+filter+'"]');

            if ( block.length > 0 ) {
                let position = me.position();

                // console.log(position);
                let block_h = block.outerHeight();

                block.removeClass("show");
                me.toggleClass("active");

                if ( me.hasClass("active") ) {
                    me.siblings().removeClass("active");
                    body.addClass("show-filter");
                    tags.addClass("hidden");
                } else {
                    body.removeClass("show-filter");

                    setTimeout(function() {
                        tags.removeClass("hidden");
                    }, 400);

                }

                if(body.hasClass("show-filter")) {
                    block.css("left", position.left + "px");
                    block.addClass("show").siblings().removeClass("show");

                    setTimeout(function() {
                        options.css("height", block_h + "px");
                    },200);

                    product_list.css("min-height", block_h + selects_h + "px");
                    filter_wrap.css("height", block_h + selects_h + "px");

                } else {
                    block.removeClass("show");
                    options.css("height", "auto");
                    filter_wrap.css("height", selects_h + "px");
                }

                // console.log(block_h);

            }

        });

        $(".product-list .single-product").each(function () {
            let me = $(this)
            let el = me.find(".js-load-lottie")
        });

        $(document).on("click tap",".clear-filter", function () {
            console.log("clear filters");
            let block = $('.options .block');

            filterConfig.orderby = [];
            filterConfig.languages = [];
            filterConfig.tags = [];
            filterConfig.type = [];
            filterConfig.free_books = false;
            filterConfig.load_count =  filterConfig.load_default;
            filterConfig.loaded_posts =  0;
            filterConfig.offset = 0;
            filterConfig.load_more = false;

            free_books.removeClass("active");

            block.each(function () {
                let inp = $(this).find("input");
                inp.prop('checked', false);
            });

            placeTags(filterConfig);

            return false;
        });

        $(document).on("click tap",".selected-tag", function () {
            let me = $(this);
            let action = me.data("key");
            let input_val = me.data("value");
            let block = $('.tax-filter .tax-filter-wrapper .options .block[data-action="'+action+'"]');
            let data = filterConfig[action];

            if(action != "orderby") {

                $.each(data, function( key, d ) {

                    if(d) {
                        if(d['value']) {

                            if( d['value'] == input_val ) {
                                let inp = block.find("input[value='" + d.value + "']");
                                inp.prop('checked', false);
                                filterConfig[action].splice(key, 1);
                                placeTags(filterConfig);
                            }
                        }
                    }

                });

            } else {
                filterConfig[action] = [];
                placeTags(filterConfig);
            }

        });

        $(document).on("click tap",".load-more-products", function () {
            let me = $(this);
            me.find(".but").addClass("preloading");
            let loaded_posts = $('.product-list .product-list-wrapper .single-product').length;
            console.log(loaded_posts);
            filterConfig.loaded_posts = loaded_posts;
            filterConfig.load_more = true;
            filterConfig.offset = filterConfig.loaded_posts;
            filterConfig.load_count = filterConfig.load_default;
            getProducts(filterConfig, "load-more");
            return false;
        });

        tax_filter_mobile.find(".selector").each(function () {
            let me = $(this);
            let action = me.data("action");

            if(action === "filter") {
                me.on("click tap", function() {
                    body.addClass("show-mobile-filter");
                    // header.addClass("is-hidden");
                    mobile_menu_toggle.addClass("is-hidden");
                    console.log("show mobile filter");

                    setTimeout(function() {
                        // tax_filter_mobile.addClass("hidden");
                        tax_filter_mobile.removeClass("sticky");
                    }, 0);

                });
            }

        });

        $(document).on("click tap",".tax-filter-window .head .close-window", function () {
            // header.removeClass("is-hidden");
            // header.addClass("show");
            body.removeClass("show-mobile-filter");
            tax_filter_mobile.removeClass("hidden");
            return false;
        });
        $(document).on("click tap", ".tax-filter-window .clear-filter .close-btn", function () {
            // header.removeClass("is-hidden");
            // header.addClass("show");
            body.removeClass("show-mobile-filter");
            tax_filter_mobile.removeClass("hidden");
            return false;
          });
        $("select#orderby").on("change", function () {

            let obj = {
                name: $("#orderby option:selected").text(),
                value: $(this).val()
            }

            filterConfig.orderby = obj;
            console.log(filterConfig);

            getProducts(filterConfig);

        });

        if ( window.innerWidth > 1279 ) {
            $(document).on("mouseover",".mask", function () {
                hideFilter();
                return false;
            });
        }

        win.on("scroll", function () {
            let me = $(this);

            if ( window.innerWidth > 1279 ) {

                // hideFilter()

                if ( me.scrollTop() > product_list.offset().top ) {

                    if(!body.hasClass("is-hidden-sticky")) {
                        tax_filter.removeClass("hidden");
                        tax_filter.addClass("sticky");
                    } else {
                        tax_filter.removeClass("sticky");
                        tax_filter.addClass("hidden");
                    }

                    // console.log("reach product_list");

                } else {
                    tax_filter.removeClass("sticky");
                    tax_filter.removeClass("hidden");
                }

            } else {

                if ( me.scrollTop() > product_list.offset().top ) {

                    if(!body.hasClass("is-hidden-sticky")) {

                        if($(".header").hasClass("show")) {
                            tax_filter_mobile.removeClass("hidden");
                            tax_filter_mobile.addClass("sticky");
                        }

                    } else {
                        tax_filter_mobile.removeClass("sticky");

                        if($(".header").hasClass("show")) {
                            tax_filter_mobile.addClass("hidden");
                        } else {
                            tax_filter_mobile.removeClass("hidden");
                        }

                    }

                    // console.log("reach product_list");

                } else {
                    tax_filter_mobile.removeClass("sticky");
                    tax_filter_mobile.removeClass("hidden");
                }

            }

        });

    }

}